import { render, staticRenderFns } from "./MesasCardapio.vue?vue&type=template&id=2cf2892c&scoped=true"
import script from "./MesasCardapio.vue?vue&type=script&lang=js"
export * from "./MesasCardapio.vue?vue&type=script&lang=js"
import style0 from "./MesasCardapio.vue?vue&type=style&index=0&id=2cf2892c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf2892c",
  null
  
)

export default component.exports